const Module = () => import('./UroModule.vue');

import { useAuthStore } from '@/stores/authStore';

const filterPath = (to, from, next) => {
  if (to.fullPath !== to.path) {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next({ path: to.path });
  } else {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next();
  }
};

const setBreadcrumbs = (to) => {
  let breadcrumbs = [];
  const authStore = useAuthStore();

  if (authStore.user.isAdminUser && to.name === 'uroannualreport') {
      breadcrumbs.push({ label: 'Review Annual Reports', route: '/program/annualreports' });
      breadcrumbs.push({ label: to.meta.title });
  } else {
    breadcrumbs = to.meta.breadcrumb;
  }

  return breadcrumbs;
};

const moduleRoutes = {
  path: '/uro',
  component: Module,
  children: [
      {
          path: 'annualreport/:reportId',
          name: 'uroannualreport',
          props: true,
          meta: {
              title: 'Utilization Review Organization Report',
              requiresAuth: true,
              breadcrumb: [
                  { label: 'Annual Reports', route: '/annualreports' },
                  { label: 'Utilization Review Organization Report' }
              ]
          },
          component: () => import('./views/UroReportView.vue'),
          beforeEnter: filterPath
      }
  ]
};

export default router => {
  router.addRoute(moduleRoutes);
};